import React from 'react';
import { useRequestData, useLabels } from 'wsm-common-data';
import propTypes from 'prop-types';
import DetailItem from './DetailItem';
import { MOBILE } from '../global-constants';

const EventDetail = ({ startDate, endDate, time, location }) => {
	const labels = useLabels();
	const requestData = useRequestData();
	if (!startDate && !time && !location) return null;
	const isMobile = requestData.deviceType === MOBILE;
	// Determine quick info classes based on mobile state
	const quickInfoClasses = !isMobile
		? 'ddc-span5 float-right mt-5 ml-6'
		: 'my-3 p-4 bg-light';

	const dateString = `${startDate}${
		endDate && startDate !== endDate ? ` - ${endDate}` : ''
	}`;
	return (
		<div
			className={`quick-info small ddc-box-1 ${quickInfoClasses}`}
			data-testid="event-detail"
		>
			<h4>{labels.get('EVENT_DETAILS')}</h4>
			<ul className="list-unstyled">
				{startDate && (
					<DetailItem label="DATE" className="date">
						{dateString}
					</DetailItem>
				)}

				{time && (
					<DetailItem label="TIME" className="time">
						{time}
					</DetailItem>
				)}

				{location && (
					<DetailItem label="LOCATION" className="location">
						{location}
					</DetailItem>
				)}
			</ul>
		</div>
	);
};

export default EventDetail;

const EventDetailProp = {
	startDate: propTypes.string,
	endDate: propTypes.string,
	time: propTypes.string,
	location: propTypes.string
};

EventDetail.propTypes = EventDetailProp;
